function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from '../http-client';
const RESOURCE_URL = '/dashboards';
const getUrl = (id)=>`${RESOURCE_URL}/${id}`;
class DashboardHttpClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "init", ()=>{
            return this.post(`${RESOURCE_URL}/init`);
        }), _define_property(this, "createDashboard", (payload)=>{
            return this.post(RESOURCE_URL, payload);
        }), _define_property(this, "updateDashboard", (dashboardId, payload)=>{
            return this.put(getUrl(dashboardId), payload);
        }), // Add new method to update dashboard layout
        _define_property(this, "updateDashboardLayout", (dashboardId, layout)=>{
            return this.put(`${getUrl(dashboardId)}/layout`, layout);
        }), _define_property(this, "duplicateDashboard", (payload)=>{
            return this.post(`${RESOURCE_URL}/clone`, payload);
        }), _define_property(this, "deleteDashboard", (dashboardId)=>{
            return this.delete(getUrl(dashboardId));
        }), _define_property(this, "getAllDashboards", async ()=>{
            const result = await this.get(RESOURCE_URL);
            // TODO:: Check with backend to remove dashboard key and send the response directly as array.
            return result.dashboard;
        }), _define_property(this, "getDashboard", (dashboardId)=>{
            return this.get(`${RESOURCE_URL}/${dashboardId}`);
        }), _define_property(this, "getDashboardV2", (dashboardId)=>{
            return this.get(`${RESOURCE_URL}/dashboard-v2/${dashboardId}`);
        });
    }
}
export const DashboardAPI = new DashboardHttpClient();
